import update from "immutability-helper";
import React from "react";
import { Modal } from "../../../components";
import { type FlightEditProps } from "../../model";
import GeneralFlightEdit from "../flightdetailsedit/generalflightedit";
import RetrieveFlights from "../retrieveflights/retrieveflights";
import EditViewPanel from "components/panels/EditViewPanel";
import { ButtonSecondary } from "components/Atoms/Button";

interface Props {
  initialFlight: server.dto.Flight
  onExistingFlightAdded: (segments: server.dto.FlightSegment[]) => void
  onManualEntryClicked: () => void
  onFlightDetailsSaved: (flight: server.dto.Flight) => void
  onModalClose: () => void
}

interface State {
  showFlightlookup: boolean
  noArtistSelectedError: boolean
  flight: FlightEditProps
}

export default class EditExistingFlightDetailsPage extends React.Component<Props, State> {
  state: State = {
    showFlightlookup: false,
    flight: {
      phase: this.props.initialFlight.phase,
      artist: this.props.initialFlight.artist,
      travellers: this.props.initialFlight.travellers,
      bookingCode: this.props.initialFlight.bookingCode,
      travelAgency: this.props.initialFlight.travelAgency,
      notes: this.props.initialFlight.notes
    },
    noArtistSelectedError: false
  };

  onSave = async () => {
    const { flight } = this.state;

    if (this.validate()) {
      return;
    }

    const newFlight = update(this.props.initialFlight, {
      phase: { $set: flight.phase },
      artist: { $set: flight.artist },
      travellers: { $set: flight.travellers },
      bookingCode: { $set: flight.bookingCode },
      travelAgency: { $set: flight.travelAgency },
      notes: { $set: flight.notes }
    });

    const result = await window.Api.Flights.UpdateFlight(this.props.initialFlight.id, newFlight);

    this.props.onFlightDetailsSaved(result.data);
  };

  validate = (): boolean => {
    const noArtistSelectedError = this.state.flight.artist == null;
    this.setState({ noArtistSelectedError });
    return noArtistSelectedError;
  };

  public render(): JSX.Element {
    const headerButton = site.permissions.flight.canCreate
      ? <ButtonSecondary onClick={() => { this.setState({ showFlightlookup: true }); }} label={RESX.Flight.AddSegment} />
      : null;

    return <>
      <Modal
        handleClose={this.props.onModalClose}
        title={RESX.Flight.resxFlight}
        isOpen
        width={"large"}
        height={800}
        hasAutoScrollBox
        headerButton={headerButton}
      >
        <EditViewPanel
          className="grow1 scrollbox-auto"
          title={RESX.Flight.resxFlight}
        >
          <GeneralFlightEdit
            noArtistError={this.state.noArtistSelectedError}
            flight={this.state.flight}
            onFlightEdit={flight => { this.setState({ flight }); }}
          />
        </EditViewPanel>

        <div className="flex margin-top-large justify-end">
          <div>
            <button type="button" onClick={this.onSave} className="button-new primary" value={RESX.Buttons.btnSave} name="Save">
              {RESX.Buttons.btnSave}
            </button>
          </div>
        </div>

      </Modal>
      {this.state.showFlightlookup && (
        <Modal
          title={RESX.Flight.FlightLookup}
          width={"large"}
          minHeight={450}
          height={600}
          isOpen={this.state.showFlightlookup}
          handleClose={() => { this.setState({ showFlightlookup: false }); }}
        >
          <RetrieveFlights
            onManualEntryClicked={this.props.onManualEntryClicked}
            onSelectWithSegmentClicked={this.props.onExistingFlightAdded}
          />
        </Modal>
      )}
    </>;
  }
}
